import React, { useMemo } from "react";
import MyDropdown from "../../../Common/my-dropdown/my-dropdown-new.component";
import ThreeDotsIcon from "../../../icons/three-dots.icon";
import styles from "./index.module.scss";

enum TagActionType {
  TOGGLE_DISABLE = "TOGGLE_DISABLE",
  DELETE = "DELETE",
}

interface TagAction {
  id: TagActionType;
  label: string;
  className: string;
}

interface TagActionsMenuProps {
  isDisabled?: boolean;
  onToggleDisable?: () => void;
  onDelete?: () => void;
}

const TagActionsMenu: React.FC<TagActionsMenuProps> = ({
  isDisabled,
  onToggleDisable,
  onDelete,
}) => {
  const handleAction = (actionType: TagActionType) => {
    switch (actionType) {
      case TagActionType.TOGGLE_DISABLE:
        onToggleDisable?.();
        break;
      case TagActionType.DELETE:
        onDelete?.();
        break;
      default:
        break;
    }
  };

  const actions: TagAction[] = useMemo(
    () => [
      {
        id: TagActionType.TOGGLE_DISABLE,
        label: isDisabled ? "Enable" : "Disable",
        className: "f-grey f-14 line-height-22",
      },
      {
        id: TagActionType.DELETE,
        label: "Delete",
        className: "f-red f-14 line-height-22",
      },
    ],
    [isDisabled]
  );

  return (
    <MyDropdown onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <MyDropdown.Toggle hideArrow className={styles.actionsButton}>
        <div className={styles.actionsContent}>
          <ThreeDotsIcon />
        </div>
      </MyDropdown.Toggle>
      <MyDropdown.Menu className={styles.actionsMenu} popperConfig={{ strategy: "fixed" }} renderOnMount>
        {actions.map((action) => (
          <MyDropdown.Item
            key={action.id}
            onClick={() => handleAction(action.id)}
            className={action.className}
          >
            {action.label}
          </MyDropdown.Item>
        ))}
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default TagActionsMenu;

